/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  construction_plan_area_id: z.string().uuid(),
  location_division_id: z.number(),
  slot: z.number(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
  slot: base.shape.slot.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.string().uuid() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const ConstructionPlanAreaLocationBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type ConstructionPlanAreaLocationBase = z.infer<typeof base>;
export type ConstructionPlanAreaLocationBasePutPayload = z.infer<typeof put>;
export type ConstructionPlanAreaLocationBasePatchPayload = z.infer<typeof patch>;
export type ConstructionPlanAreaLocationBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type ConstructionPlanAreaLocationBaseCreateAttributes = z.infer<typeof create>;
export type ConstructionPlanAreaLocationBaseUpdateAttributes = z.infer<typeof update>;
export type ConstructionPlanAreaLocationBaseCacheAttributes = z.infer<typeof cache>;
export type ConstructionPlanAreaLocationBaseCachesAttributes = z.infer<typeof caches>;